import { TEAM_MAPPING } from '../constants/index.js';

export function formatNumber(num) {
  if (num === null || num === undefined) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatCompactNumber(num) {
    const value = Number(num);
    if (!Number.isFinite(value) || value <= 0) return '0';

    const abs = Math.abs(value);
    if (abs < 1000) return String(Math.floor(abs));

    if (abs < 1_000_000) {
        const scaled = abs / 1000;
        const isExactK = abs % 1000 === 0;
        const decimals = isExactK ? 0 : 1;
        return `${scaled.toFixed(decimals)}k`;
    }

    const scaled = abs / 1_000_000;
    const isExactM = abs % 1_000_000 === 0;
    const decimals = isExactM ? 0 : 1;
    return `${scaled.toFixed(decimals)}m`;
}

export function getTeamBySlot(playerSlot) {
  const slot = parseInt(playerSlot);
  if (TEAM_MAPPING.amber.includes(slot)) {
    return 'amber';
  } else if (TEAM_MAPPING.sapphire.includes(slot)) {
    return 'sapphire';
  }
  return 'unknown';
}
